import React from 'react'

const CountCardsSkeleton = () => {
  return (
    <div className='flex gap-8 mb-6'>
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className='w-1/3 p-4 border rounded-lg bg-[var(--color-common-bg-base)] border-[var(--color-common-border)] animate-pulse'
        >
          <div className='flex items-center mb-4'>
            <div className='h-8 w-8 bg-gray-200 rounded-full'></div>
            <div className='ml-4 h-6 bg-gray-200 rounded w-1/2'></div>
          </div>
          <div className='flex justify-around'>
            <div className='text-center'>
              <div className='h-4 w-12 bg-gray-200 rounded mb-2'></div>
              <div className='h-8 w-8 bg-gray-200 rounded-full mx-auto'></div>
            </div>
            <div className='text-center'>
              <div className='h-4 w-12 bg-gray-200 rounded mb-2'></div>
              <div className='h-8 w-8 bg-gray-200 rounded-full mx-auto'></div>
            </div>
            <div className='text-center'>
              <div className='h-4 w-12 bg-gray-200 rounded mb-2'></div>
              <div className='h-8 w-8 bg-gray-200 rounded-full mx-auto'></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CountCardsSkeleton
